import {Tags} from "@/model/materials/tags";
import {Gifts} from "@/model/materials/gifts";
import {Pictures} from "@/model/materials/pics";
import {Introductions} from "@/model/materials/introductions";
import {Themes} from "@/model/materials/themes";
import {Titles} from "@/model/materials/titles";

export class Material {
    tags: Tags;
    gifts: Gifts
    pics: Pictures
    introductions: Introductions;
    themes: Themes
    titles: Titles;

    constructor(data: { [key: string]: any }) {
        this.tags = new Tags(data.tag_tree, data.tags);
        this.gifts = new Gifts(data.gifts);
        this.pics = new Pictures(data.pictures);
        this.introductions = new Introductions(data.shop_introduction_templates);
        this.themes = new Themes(this, data.themes);
        this.titles = new Titles(data.titles);
    }
}
